import React from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const PolaroidModal = ({ open, onClose, image, caption }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}
    >
      <DialogContent
        style={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '20px',
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
          width: 'fit-content',
        }}
      >
        <IconButton
          aria-label="close"
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 10,
            right: 10,
            color: '#333',
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            borderRadius: '50%',
          }}
        >
          <CloseIcon />
        </IconButton>
        {image && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              backgroundColor: '#fff',
              padding: '10px',
              border: '1px solid #ddd',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              borderRadius: '8px',
            }}
          >
            <img
              src={image}
              alt={caption}
              style={{
                maxWidth: '100%',
                maxHeight: '80vh',
                objectFit: 'contain',
                borderRadius: '4px',
              }}
            />
            <div
              style={{
                marginTop: '8px',
                fontSize: '16px',
                color: '#555',
                fontStyle: 'italic',
                textAlign: 'center',
              }}
            >
              {caption}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PolaroidModal;